module.exports = __webpack_public_path__ + "static/media/foot-grid.d18a1cfd.png";